module.exports = __webpack_public_path__ + "static/media/sticker-13.5b620f2e.png";